import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Flex,
  Grid,
  GridItem,
  Avatar,
  Text,
  Icon,
  Button,
  Select,
  useToast,
  FormControl,
  FormLabel,
  IconButton,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from "@chakra-ui/react";
import {
  FaFilter,
  FaClock,
  FaBook,
  FaSync,
  FaPrint,
  FaPlus,
  FaTrashAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Print_pdf_class_time from "./print_pdf_class_time";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Admin_staff_tt = () => {
  const cancelRef = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(""); // Selected staff ID
  const [staffList, setStaffList] = useState([]); // Staff list
  const [timetableData, setTimetableData] = useState([]); // Timetable data
  const [days, setDays] = useState([]); // Days for timetable
  const [slotToDelete, setSlotToDelete] = useState(null);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef();
  const toast = useToast(); // Initialize toast
  const colors = [
    "red.100",
    "green.100",
    "blue.100",
    "yellow.100",
    "orange.100",
    "purple.100",
  ];

  // Fetch staff list
  // useEffect(() => {
  //   const school_id = sessionStorage.getItem('school_id')
  //   fetch(`https://myedudiary.com/sms/admin/staff/staff_list.php?school_id=${school_id}`)
  //     .then((response) => response.json())
  //     .then((data) => setStaffList(data.data))
  //     .catch((error) => console.error("Error fetching staff list:", error));
  // }, []);
  useEffect(() => {
    const school_id = sessionStorage.getItem("school_id");

    fetch(`${BASE_URL}/admin/staff/staff_list.php?school_id=${school_id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.data) {
          setStaffList(data.data);
        } else {
          setStaffList([]); // fallback to empty array
        }
      })
      .catch((error) => {
        console.error("Error fetching staff list:", error);
        setStaffList([]); // fallback on error
      });
  }, []);

  // Fetch timetable for the selected staff
  useEffect(() => {
    if (selectedStaff) {
      console.log("Fetching timetable for teacher ID:", selectedStaff);
      localStorage.setItem("selectedStaff", selectedStaff);

      fetch(`${BASE_URL}/admin/timetable/teacher_based_tt.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ teacher_id: selectedStaff }), // Now this is the staff_id
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("API Response:", data); // Confirm API response
          if (data.success) {
            setTimetableData(data.data || []);
            setIsDataLoaded(true); // Mark data as loaded
          } else {
            console.error("Error fetching timetable:", data.message);
          }
        })
        .catch((error) => {
          console.error("Error fetching timetable:", error);
        });
    }
  }, [selectedStaff]);
  const handlePrint = () => {
    // Only trigger print if data is fully loaded
    if (isDataLoaded && printComponentRef.current) {
      printComponentRef.current.handlePrint();
    } else {
      console.log("Data is still loading...");
    }
  };
  // Fetch days for timetable display
  useEffect(() => {
    fetch(`${BASE_URL}/admin/timetable/day_master.php`)
      .then((response) => response.json())
      .then((data) => Array.isArray(data.data) && setDays(data.data))
      .catch((error) => console.error("Error fetching days:", error));
  }, []);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // Handle delete confirmation modal
  const openDeleteModal = (slot) => {
    setSlotToDelete(slot);
    setIsModalOpen(true);
  };

  const closeDeleteModal = () => {
    setSlotToDelete(null);
    setIsModalOpen(false);
  };

  const confirmDelete = async () => {
    if (slotToDelete) {
      try {
        const response = await fetch(
          `${BASE_URL}/admin/timetable/delete_time_table.php`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              time_table_id: slotToDelete.id,
              pass: sessionStorage.getItem("user_id"),
            }),
          }
        );

        const p = {
          time_table_id: slotToDelete.id,
          pass: sessionStorage.getItem("user_id"),
        };
        console.log(p);

        const data = await response.json();
        console.log("====================================");
        console.log(data);
        console.log("====================================");
        if (data.success) {
          toast({
            title: "Time Table Deleted Successfully",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
          setTimetableData(
            timetableData.filter((slot) => slot.id !== slotToDelete.id)
          );
        } else {
          throw new Error(data.message || "Failed to delete");
        }
      } catch (error) {
        toast({
          title: "Error deleting timetable",
          description: error.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      } finally {
        closeDeleteModal();
      }
    }
  };

  return (
    <Box>
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 style={{ fontSize: "20px" }}>TimeTable</h1>
            <div className="action-buttons">
              <div className="export-dropdown">
                <Button
                  className="export-button"
                  display={{ base: "none", md: "flex" }}
                  backgroundColor="white"
                  fontSize="11px"
                  boxShadow="md"
                  onClick={handlePrint} // Attach the print handler here
                >
                  <FaPrint color="#515B73" />
                  Print PDF
                </Button>

                <div style={{ display: "none" }}>
                  <Print_pdf_class_time
                    ref={printComponentRef}
                    timetableData={timetableData}
                  />
                </div>
              </div>
              <FormControl id="staff">
                <Select
                  placeholder="Select staff"
                  value={selectedStaff}
                  onChange={(e) => setSelectedStaff(e.target.value)} // Use staff_id here
                  size={{ base: "sm", md: "md" }} // Smaller size on mobile view (base), default size on larger screens (md)
                  sx={{
                    borderColor: "gray.400", // Custom border color
                    borderWidth: "1px", // Border width
                    borderRadius: "md", // Border radius for rounded corners
                    backgroundColor: "white", // Background color
                    fontWeight: "medium", // Font weight for better readability
                    _hover: {
                      borderColor: "teal.500", // Change border color on hover
                    },
                  }}
                >
                  {staffList.map((staff) => (
                    <option key={staff.id} value={staff.id}>
                      {staff.name}{" "}
                      {/* Display the name, but use staff_id as the value */}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>

          <div className="breadcrumb">
            <Link
              to="/admin"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <span>Dashboard</span>
            </Link>{" "}
            / <span> Teacher Time Table</span>
          </div>
        </div>

        {/* Staff selection dropdown */}
        <Box p={6}>
          {/* Timetable grid */}
          {selectedStaff && (
            <Grid
              templateColumns={{
                base: "repeat(2, 1fr)",
                md: "repeat(3, 1fr)",
                lg: "repeat(5, 1fr)",
              }}
              gap={6}
              mt={4}
              p={4}
              className="sb"
            >
              {days.map((day, i) => (
                <GridItem key={day.id}>
                  <Text fontWeight="bold" mb={3}>
                    {day.day}
                  </Text>
                  {timetableData
                    .filter((slot) => slot.day === day.day)
                    .map((slot, j) => (
                      <Box
                        key={j}
                        bg={colors[Math.floor(Math.random() * colors.length)]}
                        p={4}
                        borderRadius="md"
                        mb={4}
                      >
                        <Flex alignItems="center" mb={2}>
                          <Icon as={FaClock} color="gray.500" mr={2} />
                          <Text>
                            {slot.start_time} - {slot.end_time}
                          </Text>
                        </Flex>
                        <Flex alignItems="center" mb={2}>
                          <Icon as={FaBook} color="gray.500" mr={2} />
                          <Text>Subject: {slot.subject}</Text>
                        </Flex>
                        <Flex alignItems="center">
                          <Icon as={FaBook} color="gray.500" mr={2} />

                          <Text
                            fontWeight="bold"
                            fontSize="lg"
                            color="teal.600"
                          >
                            {slot.class} {slot.division}
                          </Text>
                        </Flex>
                        <Flex alignItems="center">
                          <Avatar src={slot.image_url} size="sm" mr={2} />
                          <Text>{slot.name}</Text>
                        </Flex>
                        <Flex justify="flex-end" mt={2}>
                          <IconButton
                            icon={<FaTrashAlt />}
                            colorScheme="red"
                            onClick={() => openDeleteModal(slot)}
                            aria-label="Delete timetable"
                            size="sm"
                          />
                        </Flex>
                      </Box>
                    ))}
                </GridItem>
              ))}
            </Grid>
          )}
          {/* Confirm Delete Modal */}
          <AlertDialog
            isOpen={isModalOpen}
            leastDestructiveRef={cancelRef}
            onClose={closeDeleteModal}
          >
            <AlertDialogOverlay>
              <AlertDialogContent>
                <AlertDialogHeader fontSize="lg" fontWeight="bold">
                  Delete Timetable Slot
                </AlertDialogHeader>

                <AlertDialogBody>
                  Are you sure you want to delete this timetable slot? This
                  action cannot be undone.
                </AlertDialogBody>

                <AlertDialogFooter>
                  <Button ref={cancelRef} onClick={closeDeleteModal}>
                    Cancel
                  </Button>
                  <Button colorScheme="red" onClick={confirmDelete} ml={3}>
                    Delete
                  </Button>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialogOverlay>
          </AlertDialog>
        </Box>
      </div>
    </Box>
  );
};

export default Admin_staff_tt;
